import { Box, Card, CardContent, Typography } from "@mui/material";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

const Avisos = () => {
    return (
        <Box sx={{ position: "relative", height: "100%" }}>
            <Card sx={{
                width: "100%",
                height: "100%",
                background: "linear-gradient(145deg, #fff9f0 0%, #fff3e0 60%, #ffecc8 100%)",
                boxShadow: "0 8px 32px rgba(202, 97, 17, 0.15), 0 2px 8px rgba(202, 97, 17, 0.08)",
                borderRadius: "16px",
                border: "1px solid rgba(202, 97, 17, 0.2)",
                overflow: "hidden",
                position: "relative",
                "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "4px",
                    background: "linear-gradient(90deg, #CA6111, #E8922A, #FFB347)",
                },
            }}>
                <CardContent sx={{
                    pt: 3,
                    pb: "20px !important",
                    height: "100%",
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <Typography variant="h6" sx={{
                        fontWeight: 700,
                        color: "#7A4010",
                        letterSpacing: "0.5px",
                        mb: 2,
                    }}>
                        Avisos
                    </Typography>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        py: 3,
                    }}>
                        <Box sx={{
                            width: 64,
                            height: 64,
                            borderRadius: "50%",
                            background: "linear-gradient(135deg, rgba(202,97,17,0.15), rgba(202,97,17,0.08))",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mb: 1.5,
                            border: "1px solid rgba(202,97,17,0.2)",
                        }}>
                            <NotificationsActiveIcon sx={{ fontSize: 32, color: "#CA6111" }} />
                        </Box>
                        <Typography variant="body2" sx={{ color: "#a05a30", fontWeight: 500 }}>
                            Nenhum aviso no momento
                        </Typography>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default Avisos;
